/**
 * The one intent failure whose CAUSE the client actually knows (MYAC-1041).
 *
 * `sendAssessmentIntent` rejects for four different reasons — not signed in, a
 * rules refusal on the command write, the local runner being unreachable, and
 * the 30s admission timeout — and its caller catches all four in one place. Only
 * the last of them justifies telling the user to check their connection; the
 * others are answered by `reason.internal`, because "something went wrong" is
 * true and "check your connection" is a guess that sends the reader to their
 * router.
 *
 * **Why this lives in its own module rather than in `useAssessmentIntents`.**
 * The thrower and the catcher are different modules, and the catcher's tests
 * mock the thrower wholesale (`vi.mock('@/composables/useAssessmentIntents')`).
 * An error class exported from there would come back `undefined` through any
 * such mock, and `e instanceof undefined` throws a TypeError — so the honest
 * "internal" branch would blow up in exactly the tests written to pin it, and
 * every future mock would silently inherit the obligation to re-export it. A
 * shared contract between two modules belongs to neither.
 */
export class IntentAdmissionTimeout extends Error {
  constructor(message: string) {
    super(message)
    // Set explicitly: subclassing a built-in leaves `name` as "Error", and this
    // is the string that reaches the log line an operator reads.
    this.name = 'IntentAdmissionTimeout'
  }
}
